export const toGCPInputCreateRequest = ({
  clientId,
  serviceAccountKey,
  logs,
  gcpName,
  gcpThrottleEnabled,
  pollingInterval,
  projectId,
  gcpRegion,
  pageSize
}) => ({
  name: gcpName.value,
  log_types: logs.value.split(","),
  polling_interval: pollingInterval.value,
  polling_time_unit: "MINUTES",
  gcp_project_id: projectId.value,
  enable_throttling: !!(gcpThrottleEnabled == null ? void 0 : gcpThrottleEnabled.value),
  gcp_client_id: clientId.value,
  gcp_service_account_key: serviceAccountKey.fileContent,
  gcp_region: gcpRegion == null ? void 0 : gcpRegion.value,
  page_size: pageSize.value
});
export const toGenericInputCreateRequest = ({
  clientId,
  serviceAccountKey,
  logs,
  gcpName,
  gcpThrottleEnabled,
  pollingInterval,
  projectId,
  gcpRegion,
  pageSize
}) => ({
  type: "org.graylog.enterprise.integrations.gcp.GCPInput",
  title: gcpName.value,
  global: false,
  configuration: {
    log_types: logs.value.split(","),
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES",
    project_id: projectId.value,
    throttling_allowed: !!(gcpThrottleEnabled == null ? void 0 : gcpThrottleEnabled.value),
    client_id: clientId.value,
    service_account_key: serviceAccountKey.fileContent,
    gcp_region: gcpRegion == null ? void 0 : gcpRegion.value,
    page_size: pageSize.value
  }
});
